import { Link } from "react-router-dom";
import { Seo } from "@/components/site/Seo";
import { SiteLayout } from "@/components/site/SiteLayout";
import { Logo } from "@/components/site/Logo";

export default function NotFound() {
  return (
    <SiteLayout>
      <Seo title="404 - Sayfa Bulunamadı" robots="noindex,follow" />
      <section className="max-w-xl mx-auto px-4 py-24 text-center">
        <Logo className="h-12 mx-auto mb-8" />
        <h1 className="text-7xl font-extrabold text-gradient">404</h1>
        <p className="text-gray-400 mt-4 text-lg">Aradığınız sayfa bulunamadı.</p>
        <Link to="/" className="btn-gradient inline-block mt-8 px-8 py-3 rounded-xl font-bold">Ana Sayfaya Dön</Link>
      </section>
    </SiteLayout>
  );
}
